import {
  USER_LOADED,
  LOGIN_SUCCESS,
  REFRESH_TOKEN,
  EXPIRED_TOKEN,
  LOGIN_FAIL,
  LOGOUT_SUCCESS,
  AUTH_ERROR,
  SET_AUTH_LOADING,
  PASS_FAIL,
  POST_NEWPASS,
  

} from '../actions/types'

const initialState = {
  token: localStorage.getItem("token"),
  refresh: localStorage.getItem("refresh"),
  isAuthenticated: null,
  auth_loading: localStorage.getItem("token")!==null,
  user: null,
  error: null,
  errorPass:null,
  res:null,
};

// eslint-disable-next-line
export default (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      localStorage.setItem("token", action.payload.access)
      localStorage.setItem("refresh", action.payload.refresh)
      return {
        ...state,
        token: action.payload.access,
        refresh: action.payload.refresh,
        isAuthenticated: true,
        auth_loading: false,
        error:null
      }
    case REFRESH_TOKEN:
      localStorage.setItem("token", action.payload.access)
      return {
        ...state,
        token: action.payload.access,
        isAuthenticated: true,
        auth_loading: false,
        error:null
      }
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        auth_loading: false,
        user: action.payload,
        error:null
      }
    case AUTH_ERROR:
    // eslint-disable-next-line
    case LOGIN_FAIL:
      return {
        ...state,
        token: null,
        isAuthenticated: null,
        auth_loading: false,
        user: null,
        error: action.payload
      }
    case LOGOUT_SUCCESS:
      localStorage.removeItem("token");
      localStorage.removeItem("refresh");
      return {
        ...state,
        token: null,
        refresh: null,
        isAuthenticated: null,
        auth_loading: false,
        user: null,
        error: null,
      }
    case EXPIRED_TOKEN:
      localStorage.removeItem("token");
      return {
        ...state,
        token: null,
        isAuthenticated: null,
        auth_loading: false,
        user: null,
        error: null,
      }
    case SET_AUTH_LOADING:
      return{
        ...state,
        auth_loading:true,
        errorPass:null
      }
    case POST_NEWPASS:
      return {
        ...state,
        auth_loading: false,
        errorPass: null,
        res: action.payload
      }
    case PASS_FAIL:
      return {
        ...state,
        auth_loading: false,
        errorPass: action.payload,
        res: null
      }

    default:
      return state;
  }
}